const main = () => {
    const panel = document.querySelector('.l-header__mega-panel');
    if (!panel) return;

    const triggers = document.querySelectorAll('[data-mega-trigger], [data-open-search-menu]');
    if (!triggers.length) return;

    const close = () => {
        document.body.removeAttribute('data-mega-active');
        panel.removeAttribute('data-hide-others');
    };

    const open = (trigger) => {
        document.body.setAttribute('data-mega-active', '');
        if (trigger.hasAttribute('data-search-menu-hide-others')) {
            panel.setAttribute('data-hide-others', '');
        } else {
            panel.removeAttribute('data-hide-others');
        }
    };

    triggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            if (document.body.hasAttribute('data-mega-active')) {
                close();
            } else {
                open(trigger);
            }
        });
    });

    // オーバーレイクリックで閉じる
    const overlay = document.querySelector('.l-header__mega-overlay');
    if (overlay) {
        overlay.addEventListener('click', close);
    }

    // パネル外クリックで閉じる（PC）
    document.addEventListener('click', (e) => {
        if (
            !e.target.closest('[data-mega-trigger]') &&
            !e.target.closest('.l-header__mega-panel') &&
            !e.target.closest('[data-open-search-menu]')
        ) {
            close();
        }
    });

    // STEP1セレクト変更時にカードのhrefを更新
    const nativeSelect = panel.querySelector('.c-others-select-search__native');
    if (nativeSelect) {
        const updateLinks = () => {
            const type = nativeSelect.value;
            panel.querySelectorAll('[data-mega-link]').forEach(link => {
                const url = new URL(link.href, location.origin);
                url.searchParams.set('type', type);
                link.href = url.pathname + url.search;
            });
        };
        nativeSelect.addEventListener('change', updateLinks);
        updateLinks();
    }
}

export default main;
